var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaundry({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / \xD0\x9F\xD1\x80\xD0\xB0\xD1\x87\xD0\xB5\xD1\x87\xD0\xBD\xD0\xB0\xD1\x8F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M31.2502 4.1665V7.08317C31.2502 8.24995 31.2502 8.83333 31.0231 9.27898C30.8234 9.67099 30.5047 9.9897 30.1126 10.1894C29.667 10.4165 29.0836 10.4165 27.9168 10.4165H22.0835C20.9167 10.4165 20.3333 10.4165 19.8877 10.1894C19.4957 9.9897 19.177 9.67099 18.9772 9.27898C18.7502 8.83333 18.7502 8.24995 18.7502 7.08317V4.1665M15.0002 45.8332H35.0002C37.3337 45.8332 38.5005 45.8332 39.3918 45.379C40.1758 44.9796 40.8132 44.3421 41.2127 43.5581C41.6668 42.6668 41.6668 41.5001 41.6668 39.1665V10.8332C41.6668 8.49962 41.6668 7.33284 41.2127 6.44154C40.8132 5.65753 40.1758 5.02012 39.3918 4.62064C38.5005 4.1665 37.3337 4.1665 35.0002 4.1665H15.0002C12.6666 4.1665 11.4998 4.1665 10.6085 4.62064C9.82453 5.02012 9.18711 5.65753 8.78764 6.44154C8.3335 7.33284 8.3335 8.49962 8.3335 10.8332V39.1665C8.3335 41.5001 8.3335 42.6668 8.78764 43.5581C9.18711 44.3421 9.82453 44.9796 10.6085 45.379C11.4998 45.8332 12.6666 45.8332 15.0002 45.8332Z",
    stroke: "#956446",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/laundry.4ed8bb792456d9ba2a176a5846d8af32.svg";
export { ForwardRef as ReactComponent };